import PubSub from 'pubsub-js';
import { dispatcher } from '../../../helpers/projectHelper';
import {
  selectApplyTextureInProgress,
  setApplyTextureInProgress,
} from '../../../redux/slicers/admin/curatorStylesSlicer';
import {
  configuratorActions,
  selectConfiguratorId,
  selectInitialObjectProperties,
  selectObjectsAfterDeleteOperationCompleted,
  selectSelectedSceneId,
  selectSkipSaveSceneJson,
  selectUnlinkedObjectsAfterDelete,
} from '../../../redux/slicers/configurator/configurator.slicer';
import { selectSelectedOption } from '../../../redux/slicers/configurator/configuratorLabelDetails.slicer';
import {
  // selectAllLinkedObjects,
  selectCurrentSceneSortedLabels,
  selectLabelById,
} from '../../../redux/slicers/configurator/configuratorSceneLabels.slicer';
import {
  configuratorUnityObjectActions,
  selectPropFlatList,
} from '../../../redux/slicers/configurator/configuratorUnityObject.slicer';
import { getAppState } from '../../../redux/store';
import { getConfiguratorApi, updateLabelsOptimistic } from '../../../api/configuratorApi';
import { resetBaseMaterialOnObjectDelete } from './objectPropertiesMethods';
import { undoRedo } from '../../admin/curator/UndoRedo/UndoRedo';
import {
  getUpdatedLinkedObjectsToSend,
  isRetailAutomation,
  isV2,
  removeDefaultTextures,
  updateTransformInViewsOnDelete,
} from '../utils';
import { configuratorModule } from './unityMethods';

import { successToastV2 } from '../../../helpers/toastHelper';
import { debounce } from 'lodash';
import { LogCurator } from '../../../helpers/logEvents';

export const CONFIGURATOR_UNITY_EVENT = {
  RecieveConfiguratorCameraDetails: 'RecieveConfiguratorCameraDetails',
  RecieveConfiguratorTransformSelected: 'RecieveConfiguratorTransformSelected',
  ReceiveConfiguratorTransformValueChanged: 'ReceiveConfiguratorTransformValueChanged',
  OnCameraNavigate: 'OnCameraNavigate',
  ReceiveConfiguratorPropLoaded: 'ReceiveConfiguratorPropLoaded',
  ReceiveConfiguratorPropLoadedTree: 'ReceiveConfiguratorPropLoadedTree',
  OnDeleteOperationCompleted: 'OnDeleteOperationCompleted',
  OnInitializeConfigurator: 'OnInitializeConfigurator',
  GetSelectedObjectInfoOnSelection: 'GetSelectedObjectInfoOnSelection',
  OnAllConfiguratorPropsLoaded: 'OnAllConfiguratorPropsLoaded',
  OnConfiguratorSceneLoaded: 'OnConfiguratorSceneLoaded',
  OnConfiguratorStyleApplied: 'OnConfiguratorStyleApplied',
  ReceiveSelectedObjectInfo: 'ReceiveSelectedObjectInfo',
  OnRoomLoadedCompletely: 'OnRoomLoadedCompletely',
  OnReceiveInitialObjectProperties: 'OnReceiveInitialObjectProperties',
  OnReceiveAllInitialObjectProperties: 'OnReceiveAllInitialObjectProperties',
  OnReceiveLabelObjectProperties: 'OnReceiveLabelObjectProperties',
  GetRoomInfo: 'GetRoomInfo',
  OnReceiveObjectNameOnHover: 'OnReceiveObjectNameOnHover',
  ApplyMaterialPropertiesFinishedReceive: 'ApplyMaterialPropertiesFinishedReceive',
  SelectedVariationPropFinished: 'SelectedVariationPropFinished', // Added to ensure SelectMaterialUsingMaterialNameForRetailAutomation is triggered only after receiving SelectedVariationPropFinished from Unity
  OnGroupPropLoadedForRetailAutomationCompletely: 'OnGroupPropLoadedForRetailAutomationCompletely',
  // reserved for a future Unity signal confirming the group prop's container was created,
  // mirroring Curator's OnInitializeGroupProp - not fired by Unity yet, see addGroupProp.
  OnInitializeGroupProp: 'OnInitializeGroupProp',
  OnGroupPropLoadedCompletely: 'OnGroupPropLoadedCompletely',
  GetLoadedLifestyleInfo: 'GetLoadedLifestyleInfo',
  GetEditInCuratorInfo: 'GetEditInCuratorInfo',
  LifeStyleUnloadInfoReceiver: 'LifeStyleUnloadInfoReceiver',
  CuratorInConfiguratorLoadedCompletely: 'CuratorInConfiguratorLoadedCompletely',
  RightClickCallbackReceiver: 'RightClickCallbackReceiver',
  OpenRightClickPanel: 'OpenRightClickPanel',
  ClickedObjectNameReceiver: 'ClickedObjectNameReceiver',
  OnReceiveUnlinkedObjectNames: 'OnReceiveUnlinkedObjectNames',
  AllSelectedObjectsDeletedReceiver: 'AllSelectedObjectsDeletedReceiver',
};

export const CONFIGURATOR_APP_EVENT = {
  RESET_CONFIGURATOR_SCENE: 'RESET_CONFIGURATOR_SCENE',
};

export const initGlobalCallbacks = () => {
  window.RecieveConfiguratorCameraDetails = (cameraJSON) => {
    const camera = JSON.parse(cameraJSON);
    PubSub.publish(CONFIGURATOR_UNITY_EVENT.RecieveConfiguratorCameraDetails, camera);
  };

  window.RecieveConfiguratorTransformSelected = (dataJson) => {
    const data = JSON.parse(dataJson);
    console.warn('RecieveConfiguratorTransformSelected', data);
    dispatcher(configuratorUnityObjectActions.setSelectedObjects(data));
    dispatcher(configuratorUnityObjectActions.setSelectedBackupObjects(data));
    PubSub.publish(CONFIGURATOR_UNITY_EVENT.RecieveConfiguratorTransformSelected, data);
    // if (isRetailAutomation()) {
    //   dispatcher(retailAutomationActions.setClickedUnityObjectPartInfo(data))
    // }
  };

  window.ReceiveConfiguratorTransformValueChanged = (dataJson) => {
    const data = JSON.parse(dataJson);
    dispatcher(configuratorUnityObjectActions.syncObjectTransform({ transformData: data }));
    PubSub.publish(CONFIGURATOR_UNITY_EVENT.ReceiveConfiguratorTransformValueChanged, data);
  };

  window.OnCameraNavigate = () => {
    PubSub.publish(CONFIGURATOR_UNITY_EVENT.OnCameraNavigate);
  };

  window.ReceiveConfiguratorPropLoaded = (propJson) => {
    // const prop = JSON.parse(propJson);
    LogCurator('ReceiveConfiguratorPropLoaded', propJson);
    PubSub.publish(CONFIGURATOR_UNITY_EVENT.ReceiveConfiguratorPropLoaded, JSON.parse(propJson));
  };

  window.ReceiveConfiguratorPropLoadedTree = (dataJson) => {
    let items = JSON.parse(dataJson);
    items = items.map((a) => {
      return {
        ...a,
        objectName: a.childName,
        name: a.actualChildName,
      };
    });
    PubSub.publish(CONFIGURATOR_UNITY_EVENT.ReceiveConfiguratorPropLoadedTree, items);
    dispatcher(configuratorUnityObjectActions.addPropToTree(items));
  };

  window.GetRoomInfo = (roomInfoJson) => {
    const roomInfo = JSON.parse(roomInfoJson);
    PubSub.publish(CONFIGURATOR_UNITY_EVENT.GetRoomInfo, roomInfo);
  };

  window.OnDeleteOperationCompleted = (objectListJson) => {
    const objectList = JSON.parse(objectListJson);
    PubSub.publish(CONFIGURATOR_UNITY_EVENT.OnDeleteOperationCompleted, objectList);
  };

  window.OnInitializeConfigurator = () => {
    PubSub.publish(CONFIGURATOR_UNITY_EVENT.OnInitializeConfigurator);
  };

  window.OnAllConfiguratorPropsLoaded = () => {
    // this callback is never executed if there is no props :(
    PubSub.publish(CONFIGURATOR_UNITY_EVENT.OnAllConfiguratorPropsLoaded);
    dispatcher(configuratorActions.setAllSceneInitPropsLoaded(true));
  };

  window.OnConfiguratorStyleApplied = () => {
    if (selectApplyTextureInProgress(getAppState())) {
      // dispatcher(configuratorUnityObjectPropertiesActions.setApplyTextureInProgress(false));
      dispatcher(setApplyTextureInProgress(false));
    }
    PubSub.publish(CONFIGURATOR_UNITY_EVENT.OnConfiguratorStyleApplied);
  };

  window.OnConfiguratorSceneLoaded = () => {
    dispatcher(configuratorActions.setUnityBaseSceneReady(true));
    PubSub.publish(CONFIGURATOR_UNITY_EVENT.OnConfiguratorSceneLoaded);
  };

  window.ReceiveSelectedObjectInfo = (dataJson) => {
    let data;
    if (isRetailAutomation() && dataJson) {
      data = dataJson;
    } else {
      try {
        // filter properties here, we want to update properties only if there is an option which is currently editing and if the object belongs to that label
        data = JSON.parse(dataJson);
        // we care only about current edit object properties -> if there is no edit object or object is from different label we just skip the event
        // if this filtering will cause issues in future -> add filtering parameter to `useUnityEvents` but it might cause issues
        const objectName = data.objectName;
        const state = getAppState();
        const currentEditOption = selectSelectedOption(state);
        if (!currentEditOption) return;
        const labelId = currentEditOption.sceneoption;
        const currentSceneId = selectSelectedSceneId(state);
        const label = selectLabelById(labelId, currentSceneId)(state);
        const linkedObjects = label?.data?.linkedObjects || [];
        const object = linkedObjects.find((o) => o.objectName === objectName);
        if (!object) {
          const allObjectProperties = selectInitialObjectProperties(getAppState());
          const blenderObjectName = data?.blenderObjectName || data?.objectName;
          const objectFromInitialProperties = allObjectProperties?.find((val) => {
            const objectName = val?.blenderObjectName || val?.objectName;
            return objectName === blenderObjectName;
          });
          if (!objectFromInitialProperties) {
            return;
          }
        }
      } catch (e) {
        data = null;
      }
    }
    PubSub.publish(CONFIGURATOR_UNITY_EVENT.ReceiveSelectedObjectInfo, data);
  };

  window.GetSelectedObjectInfoOnSelection = (objectListJson) => {
    const objectList = JSON.parse(objectListJson) || [];
    PubSub.publish(CONFIGURATOR_UNITY_EVENT.GetSelectedObjectInfoOnSelection, objectList);
  };

  window.OnRoomLoadedCompletely = () => {
    PubSub.publish(CONFIGURATOR_UNITY_EVENT.OnRoomLoadedCompletely);
    const skipSaveSceneJson = selectSkipSaveSceneJson(getAppState());
    if (skipSaveSceneJson) return;
    configuratorModule.SetBackGroundImagePropertiesReceiver();
    undoRedo.resetHistory();
    dispatcher(configuratorActions.setUnitySceneLoaded(true));
    console.warn('room loaded completely');
  };

  window.CuratorInConfiguratorLoadedCompletely = () => {
    PubSub.publish(CONFIGURATOR_UNITY_EVENT.CuratorInConfiguratorLoadedCompletely);
  };

  window.OnReceiveInitialObjectProperties = (objectPropertiesJson) => {
    const objectProperties = JSON.parse(objectPropertiesJson);
    PubSub.publish(CONFIGURATOR_UNITY_EVENT.OnReceiveInitialObjectProperties, objectProperties);
  };

  window.OnReceiveAllInitialObjectProperties = () => {
    PubSub.publish(CONFIGURATOR_UNITY_EVENT.OnReceiveAllInitialObjectProperties);
  };

  window.OnReceiveLabelObjectProperties = (labelPropertiesJson) => {
    const properties = JSON.parse(labelPropertiesJson);
    PubSub.publish(CONFIGURATOR_UNITY_EVENT.OnReceiveLabelObjectProperties, properties);
  };

  window.OnReceiveUnlinkedObjectNames = async (unlinkedObjects) => {
    const data = JSON.parse(unlinkedObjects);
    const allObjects = selectPropFlatList(getAppState());
    const propTree = allObjects.filter((val) => data.indexOf(val.childName) === -1);
    const allLabels = selectCurrentSceneSortedLabels(getAppState());
    dispatcher(configuratorActions.setUnlinkedObjectsAfterDelete(data));
    dispatcher(configuratorUnityObjectActions.setPropTree(propTree));
    dispatcher(configuratorActions.setBackupLabels(JSON.parse(JSON.stringify(allLabels))));
    PubSub.publish(CONFIGURATOR_UNITY_EVENT.OnReceiveUnlinkedObjectNames, data);
  };

  window.AllSelectedObjectsDeletedReceiver = debounce(async () => {
    if (isRetailAutomation()) {
      PubSub.publish(CONFIGURATOR_UNITY_EVENT.AllSelectedObjectsDeletedReceiver);
      return;
    }
    const objectsAfterDeleteOperationCompleted =
      selectObjectsAfterDeleteOperationCompleted(getAppState());
    const { rawData = [], parentData = [] } = objectsAfterDeleteOperationCompleted;
    if (isV2() && rawData.length) {
      await updateTransformInViewsOnDelete({ objects: rawData });
    }
    if (parentData.length) {
      const configuratorId = selectConfiguratorId(getAppState());
      const payload = { configuratorId };
      await removeDefaultTextures({ parentObjects: parentData });
      await dispatcher(getConfiguratorApi(payload, false));
    }
    const sceneId = selectSelectedSceneId(getAppState());
    const unlinkedObjectsAfterDelete = selectUnlinkedObjectsAfterDelete(getAppState());
    const allLabels = selectCurrentSceneSortedLabels(getAppState());
    const copyData = JSON.parse(JSON.stringify(allLabels));
    const updatedLabels = copyData.map((parent) => {
      const linkedObjects = parent.data.linkedObjects;
      if (linkedObjects?.length) {
        const updateList = linkedObjects.filter(
          (val) => unlinkedObjectsAfterDelete.indexOf(val.objectName) === -1
        );
        parent.data.linkedObjects = updateList;
      }
      return parent;
    });
    if (updatedLabels?.length) {
      const updatedData = getUpdatedLinkedObjectsToSend({
        updatedLabels,
      });
      await dispatcher(updateLabelsOptimistic({ sceneId, updatedLabels: updatedData }));
    }
    if (unlinkedObjectsAfterDelete?.length) {
      await resetBaseMaterialOnObjectDelete(unlinkedObjectsAfterDelete);
    }
    if (parentData.length) {
      successToastV2('Product deleted successfully');
    }
    dispatcher(configuratorActions.setBackupLabels([]));
    dispatcher(
      configuratorActions.setObjectsAfterDeleteOperationCompleted({
        rawData: [],
        parentData: [],
      })
    );
    dispatcher(configuratorActions.resetUnlinkedObjectsAfterDelete([]));
    dispatcher(configuratorActions.setDeleteLoading(false));
    PubSub.publish(CONFIGURATOR_UNITY_EVENT.AllSelectedObjectsDeletedReceiver);
  }, 500);

  window.OnReceiveObjectNameOnHover = (objectName) => {
    PubSub.publish(CONFIGURATOR_UNITY_EVENT.OnReceiveObjectNameOnHover, objectName);
  };

  window.ApplyMaterialPropertiesFinishedReceive = () => {
    PubSub.publish(CONFIGURATOR_UNITY_EVENT.ApplyMaterialPropertiesFinishedReceive);
  };

  // Added to ensure SelectMaterialUsingMaterialNameForRetailAutomation is triggered only after receiving SelectedVariationPropFinished from Unity
  window.SelectedVariationPropFinished = () => {
    PubSub.publish(CONFIGURATOR_UNITY_EVENT.SelectedVariationPropFinished);
  };

  window.OnGroupPropLoadedForRetailAutomationCompletely = () => {
    PubSub.publish(CONFIGURATOR_UNITY_EVENT.OnGroupPropLoadedForRetailAutomationCompletely);
  };

  // not yet fired by Unity - registered so addGroupProp's (currently commented-out) wait has
  // somewhere to subscribe once Unity adds this signal.
  window.OnInitializeGroupProp = () => {
    PubSub.publish(CONFIGURATOR_UNITY_EVENT.OnInitializeGroupProp);
  };

  window.OnGroupPropLoadedCompletely = (data) => {
    PubSub.publish(CONFIGURATOR_UNITY_EVENT.OnGroupPropLoadedCompletely, data);
  };

  window.GetLoadedLifestyleInfo = (data) => {
    PubSub.publish(CONFIGURATOR_UNITY_EVENT.GetLoadedLifestyleInfo, data);
  };

  window.GetEditInCuratorInfo = (data) => {
    PubSub.publish(CONFIGURATOR_UNITY_EVENT.GetEditInCuratorInfo, data);
  };

  window.LifeStyleUnloadInfoReceiver = (data) => {
    PubSub.publish(CONFIGURATOR_UNITY_EVENT.LifeStyleUnloadInfoReceiver, data);
  };

  window.OpenRightClickPanel = (value) => {
    const flag = Boolean(value);
    PubSub.publish(CONFIGURATOR_UNITY_EVENT.OpenRightClickPanel, flag);
  };

  window.ClickedObjectNameReceiver = (objectName) => {
    PubSub.publish(CONFIGURATOR_UNITY_EVENT.ClickedObjectNameReceiver, objectName);
  };
};
